import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { ListDaysStateType } from '../../../../../../components/internal/calendar/list/types/state';
import { MonthSelectorStateType } from '../../../../../../components/internal/calendar/selector/monthSelector/types/state';
import { YearSelectorStateType } from '../../../../../../components/internal/calendar/selector/yearSelector/types/state';
import { getShadow } from '../../../../../../designSystem/reloaded/config/shadow';
import { FONT_WEIGHT, TEXT_ALIGN } from '../../../foundations/typography';
import { ButtonSizeType, ButtonVariantType, TextVariantType } from '../../variants';
import { CalendarVariantType } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [CalendarVariantType.DEFAULT]: {
            container: {
                padding_top: FOUNDATIONS.spacing_250,
                padding_right: FOUNDATIONS.spacing_250,
                padding_bottom: FOUNDATIONS.spacing_250,
                padding_left: FOUNDATIONS.spacing_250,
                margin_top: FOUNDATIONS.spacing_150,
                background_color: FOUNDATIONS.color_comp_containers_bg,
                box_shadow: getShadow(FOUNDATIONS).shadow_100,
                border_radius: FOUNDATIONS.radius_comp_forms_calendar_radiussize,
                [DeviceBreakpointsType.TABLET]: {
                    box_shadow: 'none',
                },
                [DeviceBreakpointsType.MOBILE]: {
                    box_shadow: 'none',
                },
            },
            selectorContainer: {
                margin_bottom: FOUNDATIONS.spacing_250,
                gap: FOUNDATIONS.spacing_300,
            },
            selectorIcon: {
                color: FOUNDATIONS.color_accent_default_secondary_icon_100,
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
            },
            selectorOptions: {
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            backToDaylistContainer: {
                gap: FOUNDATIONS.spacing_100,
                variant: ButtonVariantType.PRIMARY_GHOST,
                size: ButtonSizeType.SMALL,
            },
            leftArrow: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_accent_default_secondary_icon_100,
            },
            rightArrow: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_accent_default_secondary_icon_100,
            },
            colorArrowDisabled: FOUNDATIONS.color_accent_disabled_font_100,
            backText: {
                font_variant: TextVariantType.FONT_PARAGRAPH_200,
                font_weight: FONT_WEIGHT.font_bold,
                color: FOUNDATIONS.color_accent_default_primary_font_100,
            },
            useDaySelector: false,
            weekDayContainer: {
                padding: FOUNDATIONS.spacing_150,
            },
            weekDay: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_100,
            },
            daysList: {
                container: {
                    display: 'grid',
                    grid_template_rows: 'repeat(6, minmax(0px, 1fr))',
                    gap: FOUNDATIONS.spacing_100,
                },
                dayItem: {
                    width: FOUNDATIONS.size_400,
                    height: FOUNDATIONS.size_400,
                    [ListDaysStateType.DEFAULT]: {
                        font_weight: FONT_WEIGHT.font_regular,
                        text_align: TEXT_ALIGN.center,
                        color: FOUNDATIONS.color_comp_forms_input_filled_font,
                        border: FOUNDATIONS.border_00,
                        border_radius: FOUNDATIONS.radius_00,
                    },
                    [ListDaysStateType.DISABLED]: {
                        cursor: 'auto',
                        pointer_events: 'none',
                        background_color: 'transparent',
                        font_weight: FONT_WEIGHT.font_regular,
                        text_align: TEXT_ALIGN.center,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    [ListDaysStateType.CURRENT_DAY_DISABLED]: {
                        cursor: 'auto',
                        pointer_events: 'none',
                        background_color: 'transparent',
                        font_weight: FONT_WEIGHT.font_regular,
                        text_align: TEXT_ALIGN.center,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                        border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_accent_disabled_font_100}`,
                        border_radius: `${FOUNDATIONS.radius_1000}`,
                    },
                    [ListDaysStateType.CURRENT_DAY]: {
                        font_weight: FONT_WEIGHT.font_regular,
                        text_align: TEXT_ALIGN.center,
                        color: FOUNDATIONS.color_comp_forms_input_filled_font,
                        border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_comp_forms_calendar_current_border}`,
                        border_radius: FOUNDATIONS.radius_1000,
                    },
                    [ListDaysStateType.SELECTED]: {
                        font_weight: FONT_WEIGHT.font_regular,
                        text_align: TEXT_ALIGN.center,
                        color: FOUNDATIONS.color_comp_forms_calendar_selected_font,
                        border_radius: `${FOUNDATIONS.radius_1000}`,
                        background_color: FOUNDATIONS.color_comp_forms_calendar_selected_bg,
                    },
                    [ListDaysStateType.MIDLE_DATE_RANGE]: {
                        font_weight: FONT_WEIGHT.font_regular,
                        text_align: TEXT_ALIGN.center,
                        color: FOUNDATIONS.color_neutral_font_50,
                        border_radius: FOUNDATIONS.radius_00,
                        background_color: FOUNDATIONS.color_exception_accent_selected_bg_100,
                    },
                    [ListDaysStateType.END_DATE_RANGE]: {
                        font_weight: FONT_WEIGHT.font_regular,
                        text_align: TEXT_ALIGN.center,
                        color: FOUNDATIONS.color_neutral_font_onsurface_100,
                        border: FOUNDATIONS.border_00,
                        border_radius: `${FOUNDATIONS.radius_1000}`,
                        background_color: FOUNDATIONS.color_accent_selected_bg_50,
                        background: `linear-gradient(to right, ${FOUNDATIONS.color_exception_accent_selected_bg_100} 50%, transparent 50%)`,
                    },
                    [ListDaysStateType.START_DATE_RANGE]: {
                        font_weight: FONT_WEIGHT.font_regular,
                        text_align: TEXT_ALIGN.center,
                        color: FOUNDATIONS.color_neutral_font_onsurface_100,
                        border: FOUNDATIONS.border_00,
                        border_radius: `${FOUNDATIONS.radius_1000}`,
                        background_color: FOUNDATIONS.color_accent_selected_bg_50,
                        background: `linear-gradient(to left, ${FOUNDATIONS.color_exception_accent_selected_bg_100} 50%, transparent 50%)`,
                    },
                },
            },
            monthsList: {
                row_gap: FOUNDATIONS.spacing_300,
            },
            monthListItem: {
                [MonthSelectorStateType.DEFAULT]: {
                    border_radius: FOUNDATIONS.radius_1000,
                    border: FOUNDATIONS.border_00,
                },
                [MonthSelectorStateType.CURRENT]: {
                    border_radius: FOUNDATIONS.radius_1000,
                    border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_accent_selected_border_50}`,
                },
                [MonthSelectorStateType.CURRENT_DISABLED]: {
                    cursor: 'auto',
                    pointer_events: 'none',
                    border_radius: FOUNDATIONS.radius_1000,
                    border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_accent_disabled_font_100}`,
                },
                [MonthSelectorStateType.DISABLED]: {
                    border: FOUNDATIONS.border_00,
                    cursor: 'auto',
                    pointer_events: 'none',
                },
                [MonthSelectorStateType.SELECTED]: {
                    border_radius: FOUNDATIONS.radius_1000,
                    background_color: FOUNDATIONS.color_accent_selected_bg_50,
                    border: FOUNDATIONS.border_00,
                },
            },
            monthElement: {
                [MonthSelectorStateType.DEFAULT]: {
                    padding: FOUNDATIONS.spacing_150,
                },
                [MonthSelectorStateType.CURRENT]: {
                    border_radius: FOUNDATIONS.radius_50,
                    padding: FOUNDATIONS.spacing_150,
                },
                [MonthSelectorStateType.CURRENT_DISABLED]: {
                    padding: FOUNDATIONS.spacing_150,
                },
                [MonthSelectorStateType.DISABLED]: {
                    padding: FOUNDATIONS.spacing_150,
                },
                [MonthSelectorStateType.SELECTED]: {
                    border_radius: FOUNDATIONS.radius_50,
                    padding: FOUNDATIONS.spacing_150,
                },
            },
            month: {
                [MonthSelectorStateType.DEFAULT]: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                [MonthSelectorStateType.CURRENT]: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                [MonthSelectorStateType.CURRENT_DISABLED]: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                [MonthSelectorStateType.DISABLED]: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                [MonthSelectorStateType.SELECTED]: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    color: FOUNDATIONS.color_neutral_font_onsurface_100,
                },
            },
            yearsList: {
                padding: FOUNDATIONS.spacing_150,
                row_gap: FOUNDATIONS.spacing_100,
                max_height: '18rem',
            },
            yearElement: {
                [YearSelectorStateType.DEFAULT]: {
                    padding: FOUNDATIONS.spacing_200,
                    border: FOUNDATIONS.border_00,
                },
                [YearSelectorStateType.CURRENT]: {
                    border_radius: FOUNDATIONS.radius_1000,
                    padding: FOUNDATIONS.spacing_200,
                    border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_accent_selected_border_50}`,
                },
                [YearSelectorStateType.DISABLED]: {
                    padding: FOUNDATIONS.spacing_200,
                    border: FOUNDATIONS.border_00,
                },
                [YearSelectorStateType.SELECTED]: {
                    border_radius: FOUNDATIONS.radius_1000,
                    padding: FOUNDATIONS.spacing_200,
                    background_color: FOUNDATIONS.color_accent_selected_bg_50,
                },
            },
            year: {
                [YearSelectorStateType.DEFAULT]: {
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                [YearSelectorStateType.CURRENT]: {
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                [YearSelectorStateType.DISABLED]: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                [YearSelectorStateType.SELECTED]: {
                    color: FOUNDATIONS.color_neutral_font_onsurface_100,
                },
            },
            listFooter: {
                display: 'flex',
                flex_direction: 'row-reverse',
                justify_content: 'space-between',
                background_color: FOUNDATIONS.color_comp_containers_bg,
                padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250}`,
                align_items: 'center',
                align_self: 'stretch',
                border_top: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_150}`,
                border_top_left_radius: '0',
                border_top_right_radius: '0',
                border_bottom_left_radius: FOUNDATIONS.radius_comp_forms_calendar_radiussize,
                border_bottom_right_radius: FOUNDATIONS.radius_comp_forms_calendar_radiussize,
            },
        },
    };
};
//# sourceMappingURL=default.js.map